export default __webpack_public_path__ + "static/media/info.fdf93025.svg";